/*For API Base URL*/
export const env = {
	/* Dev & QA */
	//baseUrl: "http://192.168.1.118:8090/",

	/* Prod */
	// baseUrl :  'http://20.191.119.15:7479/',
	baseUrl : 'https://filetool.cibddistributors.com:7443/',

	debug: false,
};
